import React from 'react';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/context/LanguageContext';

const GoogleMark = () => (
  <svg viewBox="0 0 48 48" className="h-[18px] w-[18px]" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"
    />
    <path
      fill="#34A853"
      d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.71C7.96 41.07 15.4 46 24 46z"
    />
    <path
      fill="#FBBC05"
      d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.71H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.89l7.35-5.71z"
    />
    <path
      fill="#EA4335"
      d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.11l7.35 5.71c1.73-5.2 6.58-9.07 12.31-9.07z"
    />
  </svg>
);

/**
 * Emergent Google Auth entry point.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export const GoogleAuthButton = ({ label, testId = 'google-auth-button' }) => {
  const { t } = useI18n();

  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = `${window.location.origin}/studyo`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Button
      type="button"
      variant="secondary"
      onClick={start}
      data-testid={testId}
      className="h-11 w-full gap-2.5 border border-[hsl(var(--border-strong))] bg-white text-[15px] font-semibold text-[#1f1f1f] transition-colors duration-150 hover:bg-[hsl(0,0%,94%)] focus-visible:ring-2 focus-visible:ring-[hsl(var(--brand-red))] active:scale-[0.99]"
    >
      <GoogleMark />
      {label || t('auth.googleContinue')}
    </Button>
  );
};
